import React, { Component } from 'react'
import {parseTimestamp} from '../../utils'

class EventDetailsDisplay extends Component {

    render(){
        const {events, selectedEventId} = this.props
        const startDetails = parseTimestamp(events[selectedEventId].start)
        const endDetails = parseTimestamp(events[selectedEventId].end)
        const eventDate = startDetails.date
        const eventStart = startDetails.time
        const eventEnd = endDetails.time
        const eventRoom = events[selectedEventId].room.name
        return(
            <div className="container-custom-event-picker">
                {
                    selectedEventId !== null ?
                    <div className="container-event-details">
                        <div className="container-event-detail-text container-right-spacing">
                            <div className="subtitle-bold inline-element">Fecha:</div> {eventDate}</div>
                        <div className="container-event-detail-text container-right-spacing">
                            <div className="subtitle-bold inline-element">Inicio:</div>{eventStart}</div>
                        <div className="container-event-detail-text container-right-spacing">
                            <div className="subtitle-bold inline-element container-right-spacing">Final:</div> {eventEnd}</div>
                        <div className="container-event-detail-text">
                            <div className="subtitle-bold inline-element">Sala:</div> {eventRoom}</div>
                    </div>
                    : <div className="container-event-detail-text"> </div>
                }
            </div>
        )
    }
}

export default EventDetailsDisplay
